// import { ChainId } from '@bidelity/sdk';
// import { ChainId } from '../index';
import { ChainId } from 'constants/contractConstants';
import MULTICALL_ABI from './abi.json';

const MULTICALL_NETWORKS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0xeefBa1e63905eF1D7ACbA5a8513c70307C1cE441',
  [ChainId.SEPOLIA]: '0xF18DCdac0E4F1b1A94012F97F0D846792c5ed7C7',
  [ChainId.BINANCETEST]: '0xD7649A160a104764Ed72E88d07322B17BbD04908',
  [ChainId.AMOY]: '0xF771707F18751a644B4066d6818cbe11B96Ea9a3',
  [ChainId.ARBITRUM]: '0x59415024c332052e19eD649700EDcb075F0422E8',
  [ChainId.FANTOM]: '0x47B1A0ad58C1BE485448E4d81843361Ba84089a3',
  [ChainId.AVALANCE]: '0x4370963Dd8295d4BF309d8541CC8a5062222dE2f',
  [ChainId.OPTIMISM]: '0x9014dAE23DfB0059A0c2bc7E6503334F213A8036',
  [ChainId.LINEA]: '0x447027b3546D9385Fb9dFF934afFAE7D0810afE0',
  [ChainId.CELO]: '0x6B05CAA2675F4400C6a137A7EE4aD08b45a5d11B',
  [ChainId.BASE]: '0x448e31F4682eE1bbF36aDF44cC38f7C9d84fd262',
  [ChainId.BLAST]: '0x448e31F4682eE1bbF36aDF44cC38f7C9d84fd262',
  [ChainId.AURORA]: '0xa3F56D161D00BdeB3147990eFb7C025Fc3211c0E',
  [ChainId.SCROLL]: '0x448e31F4682eE1bbF36aDF44cC38f7C9d84fd262',
  [ChainId.MOONBASE]: '0xa1749f0f055c6b85e600B1303DF4EBDCB3fc9635',
};

export { MULTICALL_ABI, MULTICALL_NETWORKS };
